const t = {
  name: "Monitor",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.25 6C13.25 6.69 12.69 7.25 12 7.25C11.31 7.25 10.75 6.69 10.75 6C10.75 5.31 11.31 4.75 12 4.75C12.69 4.75 13.25 5.31 13.25 6Z" fill="currentColor"/>
<path d="M0 4C0 2.34315 1.34315 1 3 1H21C22.6569 1 24 2.34315 24 4V16C24 17.6569 22.6569 19 21 19H3C1.34315 19 0 17.6569 0 16V4ZM3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17H21C21.5523 17 22 16.5523 22 16V4C22 3.44772 21.5523 3 21 3H3Z" fill="currentColor"/>
<path d="M7 23V21H17V23H7Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Monitor
};
